import { OrderTransferType } from "../../../../../../../services/Order";

import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (item: Order.Model, language: Language) => {
	type TransferValue =
		(typeof OrderTransferType)[keyof typeof OrderTransferType];

	const backgroundColorByStatus: Record<TransferValue, string> = {
		[OrderTransferType.LOCAL]: "rgb(33, 150, 243)",
		[OrderTransferType.GLOBAL]: "rgb(76, 175, 80)",
		[OrderTransferType.OUTSIDE]: "rgb(252, 151, 57)",
	};

	const executorTaxiService =
		item.executorToOrder?.[0]?.executor?.taxiService?.id;
	const { taxiService } = item;
	const taxiServiceId = taxiService?.id;
	const isOwn = item?.isOwn;
	const transfer = item?.additionalFields?.transfer;
	const fromTaxiService = transfer?.lastReceivedOrder?.taxiService;

	const currentTransferStage = transfer?.sendProcess?.currentTransferStage as
		| TransferValue
		| undefined;

	const settlement = isOwn
		? taxiService?.settlement?.[language]
		: fromTaxiService?.settlement?.[language];

	const company = isOwn
		? taxiService?.company?.name?.[language]
		: fromTaxiService?.company?.name?.[language];

	let content = "";

	if (!fromTaxiService && !isOwn) {
		content = "";
	} else if (!settlement && company) {
		content = company;
	} else {
		content = `${company} (${settlement})`;
	}

	const backgroundColor =
		executorTaxiService === taxiServiceId && isOwn
			? undefined
			: backgroundColorByStatus[currentTransferStage as TransferValue];

	let textColor: string | undefined;
	if (!(executorTaxiService === taxiServiceId && isOwn)) {
		if (
			currentTransferStage &&
			currentTransferStage !== OrderTransferType.OUTSIDE
		) {
			textColor = "#ffffff";
		}
	}

	return {
		content,
		backgroundColor,
		textColor,
	};
};

export default cellProcessing;
